import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { EmptyStateDashboard } from './emptyStateDashboard';
import { DashboardWidgetShell, DashboardWidgetSkeleton } from './widgets';
import { DashboardTabs } from './dashboardTabs';
import { AlertTabEnum, AlertTabs, formatExpiration } from './constants';
import { FindLoad } from 'utils';
import { dashboardActions } from 'store';

const ACTION_TYPE = 'GET_DASHBOARD_CLIENT_DOCUMENT_ALERTS';

/** KPI 13 — client documents (IEPs, immunization records…) expiring within 2 weeks or already expired. */
export const ClientDocumentAlertsCard = ({ item, handleDeleteWidget }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState(AlertTabEnum.EXPIRING);
    const { documentAlerts } = useSelector((state) => ({
        documentAlerts: state.dashboard.clientDocumentAlerts,
    }));
    const loader = FindLoad(ACTION_TYPE);
    const activeList = activeTab === AlertTabEnum.EXPIRING ? documentAlerts?.expiring : documentAlerts?.expired;
    const tabs = AlertTabs.map((tab) => ({
        ...tab,
        count: (tab.key === AlertTabEnum.EXPIRING ? documentAlerts?.expiring?.length : documentAlerts?.expired?.length) || 0,
    }));

    useEffect(() => {
        if (item?.apiPath) {
            dispatch(dashboardActions.getWidgetsData(ACTION_TYPE, item?.apiPath));
        }
    }, [item?.apiPath]);

    if (loader?.length) {
        return <DashboardWidgetSkeleton />;
    }

    return (
        <DashboardWidgetShell iconId={13} onClose={handleDeleteWidget}>
            <div className="dashboard-tabbed-body">
                <DashboardTabs activeKey={activeTab} onChange={setActiveTab} tabs={tabs} />

                <div className="main-dashboard-card-body">
                    {activeList?.length ? (
                        <div className={`dashboard-alert-list ${activeTab === AlertTabEnum.EXPIRED ? 'is-expired' : ''}`}>
                            {activeList.map((alert, index) => (
                                <div
                                    className="dashboard-alert-row"
                                    key={`${alert?.clientId}-${alert?.documentId || index}`}
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => navigate(`/client/${alert?.clientId}`)}
                                >
                                    <div className="dashboard-alert-row__body">
                                        {alert?.clientName && <p className="dashboard-alert-row__name">{alert?.clientName}</p>}
                                        <p className="dashboard-alert-row__sub">
                                            {alert?.documentName && <span className="dashboard-alert-row__type">{alert?.documentName}</span>}
                                            <span className="dashboard-alert-row__exp">
                                                {alert?.documentName ? ' - ' : ''}
                                                {formatExpiration(alert)}
                                            </span>
                                        </p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    ) : (
                        <EmptyStateDashboard
                            iconId={13}
                            title={activeTab === AlertTabEnum.EXPIRING ? 'No expiring documents' : 'No expired documents'}
                            description={
                                activeTab === AlertTabEnum.EXPIRING ? (
                                    <p>
                                        All client documents are up to date. <br /> Nothing is due to expire soon.
                                    </p>
                                ) : (
                                    <p>
                                        All client documents are up to date. <br /> Continue tracking to stay compliant.
                                    </p>
                                )
                            }
                        />
                    )}
                </div>
            </div>
        </DashboardWidgetShell>
    );
};
